module.exports = __webpack_public_path__ + "static/media/Socket.io.5b86b9bc.svg";